module.exports = __webpack_public_path__ + "img/player-details-bg.bfbad05c.png";